<script lang="ts">
    import type { Writable } from "svelte/store";
    import { _ } from "svelte-i18n";

    export let settings: { id: string; visible: Writable<boolean> };

    let id = settings.id;
    let visible = settings.visible;
</script>

<input
    class="form-check-input me-1"
    type="checkbox"
    id={`dataLayer-${id}`}
    name="dataLayers"
    bind:checked={$visible} />
<label class="form-check-label" for={`dataLayer-${id}`}>
    {$_(`impact.map.layersToolbox.dataLayers.${id}`)}
</label>
